import styled from 'styled-components';

export const ProgressBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 12px 16px;
  background-color: ${(props) => props.theme.colors.greys.lighter};
`;

export const ProgressBar = styled.div`
  width: 80%;
  height: 6px;
  background-color: ${(props) => props.theme.colors.greys.light};
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 8px;

  .progress-fill {
    height: 100%;
    width: ${(props) => props.usedCredits}%;
    background-color: ${(props) =>
      props.usedCredits < 70
        ? props.theme.colors.brand.primary
        : props.usedCredits < 90
        ? '#FFA500'
        : '#FF4444'};
    };
    transition: width 0.3s ease;
  }
`;

export const ProgressText = styled.div`
  font-size: 12px;
  color: ${(props) => props.theme.colors.greys.dark};
  font-weight: 500;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
`;

export const InfoIcon = styled.span`
  font-size: 14px;
  color: ${(props) => props.theme.colors.greys.dark};
  cursor: pointer;
  opacity: 0.7;

  &:hover {
    opacity: 1;
  }
`;
